<template>
  <div class="search-results">
    <search-bar-component
        class="shrink"
        v-if="isSmallScreen"
        :isSmallScreen="isSmallScreen"
        @isLoading="(loading) => $emit('isLoading', loading)"
        v-on:results="(res) => updateSearchResults(res)"
    ></search-bar-component>

    <div       v-if="!isLoading && results" class="grid gap-y-md tab-wrapper">
        <a-tabs
            :tab-bar-style="{height: 'auto'}"
                default-active-key="customer"
        >
          <a-tab-pane
              :key="key"
              v-for="(model, key) in results">
            <template #tab>
              <small class="m-0 text-primary font-size-sm">{{ resultTypes[key].title }}</small>
              <span v-if="model.data.length > 0" class="badge badge--small">{{ model.data.length }}</span>
            </template>

            <div class="flex-col gap-y-sm">
              <template v-if="model.data.length > 0" v-for="(searchResult, idx) of model.data">
                <component
                    :key="idx"
                    :is="resultTypes[key].component"
                    :result="searchResult"></component>
              </template>
            </div>
            <NothingFound v-if="model.data.length === 0" :result-type="resultTypes[key]"></NothingFound>
          </a-tab-pane>
        </a-tabs>
    </div>
    <skeleton-results v-else-if="isLoading"></skeleton-results>
    <div class="p-sm text-primary m-auto flex-col gap-y-lg justify-content-center" v-if="!results && !isLoading">
      <MagnifyIcon class="icon-size-lg color-primary"></MagnifyIcon>
      Zoek op een willekeurige term.
    </div>
    <div class="w-100 flex-row mt-auto">
      <a class="btn btn-sm btn-primary ml-auto" @click="$emit('closeModal')" href="/dashboard#customers">Alle
        dossiers</a>
    </div>
  </div>
</template>

<script>
import SearchResult from './SearchResult.vue';
import SkeletonResults from './SkeletonResults.vue';
import SearchBarComponent from "./SearchBarComponent.vue";
import Customer from "./search/results_types/Customer.vue";
import Policy from "./search/results_types/Policy.vue";
import Mortgage from "./search/results_types/Mortgage.vue";
import Damage from './search/results_types/Damage.vue';
import Credit from './search/results_types/Credit.vue';
import NothingFound from './search/components/NothingFound.vue';

export default {
  name: "SearchResults.vue",
  emits: ['results', 'isLoading', 'closeModal'],
  components: {
    SearchResult,
    SkeletonResults,
    SearchBarComponent,
    NothingFound,
  },
  props: {
    queryString: String,
    activeKeyProp: String,
    isSmallScreen: Boolean,
    isLoading: Boolean,
    results: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      activeKey: 'customer',
      defaultActiveKey: 'customer',
      resultTypes: {
        customer: {
          title: 'Dossiers',
          component: Customer,
        },
        policy: {
          title: 'Polissen',
          component: Policy,
        },
        mortgage: {
          title: 'Hypotheken',
          component: Mortgage
        },
        damage: {
          title: "Schade's",
          component: Damage,
        },
        credit: {
          title: 'Kredieten',
          component: Credit,
        }
      }
    }
  },
  methods: {
    updateSearchResults(results) {
      this.$emit('results', results);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/_default.scss';

.hourglass {
  animation: spin .3s linear infinite;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
}

.search-results {
  padding: $spacing-md;
  background-color: white;

  border-radius: $border-radius-base;
  min-height: 350px;
  max-height: calc(100vh - 100px);
  margin-bottom: auto;
  width: 100%;
  max-width: $navbar-search-width;
  margin-top: $spacing-md;
  display: flex;
  flex-direction: column;
  row-gap: $spacing-sm;
}
body.has-sidebar.collapsed-sidebar .search-results{
  transform: translateX(-25px);
}




.avatar {
  height: $spacing-xl;
  width: $spacing-xl;
  border-radius: 9999px;
  object-fit: fill;
  object-position: center;
  margin-top: auto;
  margin-bottom: auto;
}

.tab-wrapper {
  overflow-x: auto;
}
.badge {
  width: 18px;
  height: 18px;
}
</style>
<style lang="scss">
@import '~@/_default.scss';

.search-results {
  .ant-tabs-tab {
    height: auto !important;
    margin: 0;
  }
}

.result-card {
  background-color: $main-content-bg-color;
  border-right: $border-radius-base;
  padding: $spacing-xs $spacing-sm;
  font-size: $font-size-small;
  border-radius: $border-radius-base;
  color: $text-color;
  box-shadow: $shadow-xs;
  transition: box-shadow .13s ease-in-out;

  &:hover {
    box-shadow: $shadow-lg;
  }
}
.grow {
  flex-grow: 1;
  flex-shrink: 0;
}
.shrink {
  flex-shrink: 1;
  flex-grow: 0;
}
.search-results {
  .ant-tabs-content {
    height: auto;
  }
  .ant-tabs-tabpane  {
    max-height: 90%;
    overflow-y: auto;
    &::-webkit-scrollbar{
      width: 5px;
      background-color: $color-black-transparent;
    }
    &::-webkit-scrollbar-thumb{
      background-color: $color-black-less-transparent;
    }
  }
}



</style>

